export function getWidgetId(script = '') {
    console.log('script: ', script);
    let matchArr = script.match(/widget\/([^\/]+)\/([^\/]+)/);
    if (Array.isArray(matchArr) && matchArr.length >= 3) {
        return `pwm-${matchArr[1]}-${matchArr[2]}`
    } else {
        return '';
    }
}

function joinUrl(host, url) {
    if(/^https?/.test(url)){
        return url;
    } else if(/^\//.test(url)) {
        return host + url;
    } else{
        return `${host}/${url}`;
    }
}

export function handleOptionUrl(options) {
    if (options?.offline === true) {
        let widgetPath = options.widgetPath;
        options.script = `./widget/${widgetPath}/render/index.js`;
        options.style = `./widget/${widgetPath}/render/index.css`;
        return options;
    } else if (options?.widgetPath) {
        let baseOrigin = options.baseOrigin;
        if (!baseOrigin) {
            baseOrigin = ENV === 'fat' ? 'https://test-b-fat.pingan.com.cn': 'https://cdn.sdb.com.cn';
        }
        let widgetPath = options.widgetPath;
        if (baseOrigin && baseOrigin.constructor.name === 'String' && widgetPath && widgetPath.constructor.name === 'String') {
            let scriptUrl = `${baseOrigin}/widget/${widgetPath}/render/index.js`;
            let styleUrl = `${baseOrigin}/widget/${widgetPath}/render/index.css`;
            options.script = options.scriptUrlRouter ? joinUrl(baseOrigin, options.scriptUrlRouter(widgetPath, scriptUrl, options)) : scriptUrl;
            options.style = options.styleUrlRouter ? joinUrl(baseOrigin, options.styleUrlRouter(widgetPath, styleUrl, options)) : styleUrl;
        }
        return options;
    } else {
        return options;
    }
}

export function replaceErrors(key, value) {
    if (value instanceof Error) {
        let error = {};

        Object.getOwnPropertyNames(value).forEach(function (propName) {
            error[propName] = value[propName];
        });

        return error;
    }

    return value;
}